// 側邊選單輪播
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import Image from 'next/image';
import '../../styles/swiper.scss';

const MenuBannerSwiper = ({ showMenu, bannerList }) => {
    return (
        <div
            className={`rounded-[8px] img-box mt-[30px] mb-[35px] w-[174px] trans aspect-[174/260] overflow-hidden
        ${showMenu ? '' : 'w-0 h-[0] !m-0'} ulg:!block ulg:!my-[24px] ulg:!w-full ulg:!h-[unset]`}
        >
            {bannerList && bannerList?.length > 1 ? (
                <Swiper
                    className="w-full overflow-hidden h-full"
                    loop={true}
                    modules={[Autoplay]}
                    autoplay={{
                        delay: 5000,
                    }}
                >
                    {bannerList?.map((banner, i) => (
                        <SwiperSlide key={banner?.id + 'aside-banner' + i}>
                            <a
                                href={banner?.link}
                                target="_blank"
                                rel="noreferrer noopener"
                                className="gtm-banner-H01 img-box w-full aspect-[174/260] rounded-[12px] overflow-hidden flex-shrink-0"
                            >
                                <Image
                                    width={174}
                                    height={260}
                                    src={banner?.img}
                                    alt={banner?.alt || 'aside-banner'}
                                    sizes="140px"
                                />
                            </a>
                        </SwiperSlide>
                    ))}
                </Swiper>
            ) : (
                <a
                    href={bannerList?.[0]?.link}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="gtm-banner-H01 img-box w-full aspect-[174/260] rounded-[12px] overflow-hidden flex-shrink-0"
                >
                    <Image
                        width={174}
                        height={260}
                        src={bannerList?.[0]?.img}
                        alt={bannerList?.[0]?.alt || 'aside-banner'}
                        sizes="140px"
                    />
                </a>
            )}
        </div>
    );
};

export default MenuBannerSwiper;
